import { Polymorph } from '../polymorph';

export class Config {
  // url of another JS system which can provide a login UI
  host = ''; // 'https://azing.org'; // https://dev.azing.org
  loginUiUrl = '/sys/ui/user-login/' + Polymorph.GetLoginApiLocation() + '/index.html'; // './azing-js-user-login-ui/dist/index.html';
  registerUiUrl = this.loginUiUrl + '#/register';
  sessionStorageKey = 'AZING_JWT';
}
